import { findIana } from "windows-iana";

// Missing configuration means UTC; unknown/unloaded data is handled by the
// caller, not by substituting the supervisor's browser timezone.
export function resolveLocationTimeZone(value?: string | null): string | null {
	if (!value) return "UTC";
	try {
		new Intl.DateTimeFormat("en", { timeZone: value }).format();
		return value;
	} catch (error) {
		const converted = findIana(value)[0];
		if (!converted) return null;
		try {
			new Intl.DateTimeFormat("en", { timeZone: converted }).format();
			return converted;
		} catch (error) {
			return null;
		}
	}
}

export function locationDateKey(timeZone: string, instant = new Date()): string {
	const parts = new Intl.DateTimeFormat("en-US", {
		timeZone, year: "numeric", month: "2-digit", day: "2-digit",
	}).formatToParts(instant);
	const part = (type: string) => parts.find((item) => item.type === type)?.value;
	return `${part("year")}-${part("month")}-${part("day")}`;
}

export function deadlineDateKey(value: string | null, timeZone: string | null): string | null {
	if (!value || !timeZone) return null;
	const instant = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`);
	return Number.isNaN(instant.getTime()) ? null : locationDateKey(timeZone, instant);
}

export function formatLocationDeadline(value: string | null, timeZone: string | null, locale: string): string {
	if (!value || !timeZone) return "—";
	// Read-back values are UTC instants, including legacy responses without Z.
	const instant = new Date(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(value) ? value : `${value}Z`);
	if (Number.isNaN(instant.getTime())) return "—";
	return new Intl.DateTimeFormat(locale, { timeZone, year: "numeric", month: "2-digit", day: "2-digit" }).format(instant);
}
